var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.element.value),expression:"element.value"}],staticClass:"transition ease-in-out duration-300",style:(_vm.style),attrs:{"src":_vm.element.value}})}
var staticRenderFns = []

export { render, staticRenderFns }